
(function(c){var d=document,a='appendChild',i='styleSheet',s=d.createElement('style');s.type='text/css';d.getElementsByTagName('head')[0][a](s);s[i]?s[i].cssText=c:s[a](d.createTextNode(c));})
('.wdn-smallcaps{font-family:\'Mercury SSm Small Caps A\',\'Mercury SSm Small Caps B\',Georgia,serif;font-weight:400;font-style:normal}');
